module.exports = __webpack_public_path__ + "img/woman-with-computer.742d75b8.svg";